<script setup>
import { time2Date } from '#imports'
import xDate from '~/components/common/xDate.vue'

const props = defineProps({
  times: {
    type: Array,
    default: () => [],
  },
  selectDay: {
    type: Number,
    default: 0,
  },
})
const emit = defineEmits(['update:times', 'update:selectDay', 'change'])
const { t } = useI18n()
const pickerVisible = ref(false)

function handleChangeTime(val) {
  const { startDate, endDate, dayNum } = val
  const newTimes = [new Date(startDate) * 1, new Date(endDate) * 1]
  emit('update:times', newTimes)
  emit('update:selectDay', dayNum)
  emit('change', val)
}

function getDisplayTime() {
  if (props.selectDay === 0)
    return t('全部')
  if (props.selectDay === 1)
    return t('昨天')
  if (props.selectDay === 7)
    return t('近7日')
  if (props.times?.[0])
    return `${time2Date(props.times[0], 'y-m-d')} - ${time2Date(props.times[1], 'y-m-d')}`
  return t('全部')
}
</script>

<template>
  <div>
    <div class="flex items-center text-xs text-textSecondary border-b border-dividerPrimary h-10 px-4" @click="pickerVisible = true">
      {{ getDisplayTime() }}
      <SvgoReferralArrow class="text-textPrimary w-3 h-3" />
    </div>
    <xDate v-model:show="pickerVisible" :single="false" @change="handleChangeTime" />
  </div>
</template>
